'use client';

import { useEffect, useState } from 'react';

const rotatingActions = ['Optimize', 'Manage', 'Distribute', 'Scale'];

export function RotatingInventoryAction() {
  const [actionIndex, setActionIndex] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActionIndex((currentIndex) => (currentIndex + 1) % rotatingActions.length);
    }, 2200);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <span
      key={rotatingActions[actionIndex]}
      className="motion-safe:animate-[fade-in_350ms_ease-out]"
    >
      {rotatingActions[actionIndex]}
    </span>
  );
}
